module.exports = __webpack_public_path__ + "static/media/CitrusStage3.58be3d6f.PNG";